import { createContext } from "react";
import { NavigateOptions } from "react-router-dom";
import { SearchParams } from "./@types";
import { ValidateQuery } from "./hooks/useValidateQuery";
import { NavigateProps } from "./services/@types";

type SearchContextType = {
  navigate: (
    searchParams: Partial<NavigateProps>,
    navigateOptions?: NavigateOptions
  ) => void;
  location: SearchParams;
  expandApi?: {
    isExpanding: boolean;
    start: () => void;
    stop: () => void;
  };
};

const SearchFormContext = createContext<{
  search: string;
  setSearch: (search: string, debounce?: boolean) => void;
} | null>(null);

const SearchContext = createContext<SearchContextType | null>(null);

const QueryValidationContext = createContext<ValidateQuery | null>(null);

export { SearchFormContext, SearchContext, QueryValidationContext };
